import React from "react";

import { BETA_INTRO_VIDEO_EMBED_URL } from "../betaIntroVideo";

export function BetaIntroVideo() {
  return (
    <div className="aspect-video w-full overflow-hidden rounded-xl bg-default shadow-sm">
      <iframe
        src={BETA_INTRO_VIDEO_EMBED_URL}
        title="Watch Yuxin demo the new Replo"
        className="size-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        sandbox="allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts"
        allowFullScreen
      />
    </div>
  );
}
